module.exports = __webpack_public_path__ + "img/logo-full-payu.8cf29807.png";